// ABOUTME: The line shown while a translation is still being made: a slowly spinning globe and a word.
// ABOUTME: Both the field hint and the note under a text block show the same one.

import { useTranslation } from "react-i18next"
import { TranslateIcon } from "@shared/icons"

interface IProps {
  className?: string
}

export const L10nTranslatingHint = ({ className = "" }: IProps) => {
  const { t } = useTranslation()

  return (
    <div className={`mt-1 flex items-center gap-1 text-xs text-gray-500 ${className}`}>
      <span className="inline-flex animate-spin [animation-duration:2.5s]">
        <TranslateIcon
          size={12}
          color="#C4B5FD"
        />
      </span>
      <span>{t("l10n.translating")}</span>
    </div>
  )
}
